$(document).ready(function () {
    var timeFormat24To12 = (hours, minutes) => {
        if (hours == 0) return `12:${minutes.toString().padStart(2, "0")} AM`;

        output = "";
        output += hours > 12 ? hours % 12 : hours;
        output += `:${minutes.toString().padStart(2, "0")} `;
        output += hours >= 12 ? 'PM' : 'AM';

        return output;
    };

    var sqlDateTimeToMissionDate = (mysqlDate) => {
        var date = new Date(mysqlDate);
        var dateComponent = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        var timeComponent = timeFormat24To12(date.getHours(), date.getMinutes());
        return `${dateComponent} ${timeComponent}`;
    }

    // These scripts are only valid for the mission page:
    // Update or remove this early return to use this script
    // on other pages
    if ($('.page__missionDetailsById, .page__editMission').length !== 1) return;

    if ($('.page__missionDetailsById').length == 1) {
        /**
         *
         * SHARED VARIABLES
         *
         */
        var tabs = [
            '#mission_details',
            '#xeo_checklist',
            '#fly_mission',
            '#mission_data',
        ];
        var mission_aircraft = $('#aircraftSelect option:selected').val();
        var mission_sensor = $('#sensorSelect option:selected').val();
        var currentHash = window.location.hash;
        var flight_start_date = $('#flightStartDate').val();
        var flight_end_date = $('#flightEndDate').val();
        var token = $('meta[name="csrf-token"]').attr('content');
        var missionID = $('.active').data('id');


        /**
         *
         * EVENTS
         *
         */

        // Pilot Mission Details tab
        $('#aircraftSelect').on('change', function () {
            mission_aircraft = $('#aircraftSelect').val();
        });
        $('#sensorSelect').on('change', function () {
            mission_sensor = $('#sensorSelect').val();
        });

        // Pilot Fly Mission tab

        // populate dates (can't direct inject dates in blade, need to instantiate with datetimepicker)
        $.ajax({
            url: `/mission/${missionID}`,
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': token
            },
            success: function (result) {
                console.log(result);
                if(result.data.flight_date_start){
                    $('#flightStartDate').datetimepicker('date', sqlDateTimeToMissionDate(result.data.flight_date_start));
                }
                if(result.data.flight_date_end){
                    $('#flightEndDate').datetimepicker('date', sqlDateTimeToMissionDate(result.data.flight_date_end));
                }
                    
            },
            error: function (error) {
                console.log(error);
            }
        })

        if ($('#flightStartDate').val().trim() !== '') {
            $('.mission__start-stop').text('Stop')
            if ($('#flightEndDate').val().trim() !== '') {
                $('.mission__start-stop').hide();
            }
        } else {
            $('#flightEndDate').prop('disabled', true)
        }

        $('#flightEndDate').datetimepicker({
            useCurrent: false,
        });

        $('#flightStartDate').on('change.datetimepicker', function (e) {
            $('#flightEndDate').datetimepicker('minDate', e.date);
            if ($(this).val().trim() == '') {
                $('#flightEndDate').datetimepicker('disable')
                $('.mission__start-stop').text('Start');
            }
            else {
                $('#flightEndDate').datetimepicker('enable')
                $('.mission__start-stop').text('Stop');
                flight_start_date = $('#flightStartDate').val();
            }
        });

        $('#flightEndDate').on('change.datetimepicker', function (e) {
            // $('#flightStartDate').datetimepicker('maxDate', e.date);
            if ($(this).val().trim() == '') {
                $('.mission__start-stop')
                    .show()
                    .text('Stop');
            }
            else {
                $('.mission__start-stop').hide();
                flight_end_date = $('#flightEndDate').val();
            }
        });

        $('.mission__start-stop').on('click', function () {
            if ($(this).text().trim() == 'Start') {
                flight_start_date = new Date();
                flight_start_date = formatDateForDB(flight_start_date);
                $('#flightStartDate').datetimepicker('date', flight_start_date)
                $('#flightEndDate').datetimepicker('enable')
                $(this).text('Stop')
            } else {
                flight_end_date = new Date();
                flight_end_date = formatDateForDB(flight_end_date);
                $('#flightEndDate').datetimepicker('date', flight_end_date);
                $(this).hide()
            }
        })

        $('#resetFlyMission').click(function (e) {
            flight_start_date = '';
            flight_end_date = '';
            $('#flightStartDate').val(flight_start_date);
            $('#flightEndDate').val(flight_end_date);
            $('#flightEndDate').datetimepicker('disable');
            $('.mission__start-stop')
                .show()
                .text('Start');
        });

        function formatDateForDB(d) {
            Number.prototype.padLeft = function (base, chr) {
                var len = (String(base || 10).length - String(this).length) + 1;
                return len > 0 ? new Array(len).join(chr || '0') + this : this;
            }

            let ampm = d.getHours() >= 12 ? 'PM' : 'AM',
                formattedDate =
                    [(d.getMonth() + 1).padLeft(),
                    d.getDate(),
                    d.getFullYear().padLeft()].join('-')
                    + ' ' +
                    [d.getHours().padLeft(),
                    d.getMinutes().padLeft(),
                    d.getSeconds().padLeft()].join(':')
                    + ` ${ampm}`;

            return formattedDate;
        }

        // When a tab is changed, update server
        // with form data
        $('.tab-link').click(function (e) {
            e.preventDefault();
            currentHash = window.location.hash;
            var token = $('meta[name="csrf-token"]').attr('content'),
                missionID = $(this).data('id'),
                nextTabHash = $(this).attr('href'),
                postData = {
                    'id': missionID,
                    'hash': currentHash,
                };

            if (tabs.find(v => v == currentHash)) {
                var sendPost = true;

                if (currentHash == tabs[0]) {
                    postData.drone_id = mission_aircraft;
                    postData.sensor_id = mission_sensor;
                }
                else if (currentHash == tabs[1]) {
                    let checklist = {};

                    $('#xeo_checklist .form-group input').each(function (i, check) {
                        checklist[check.id] = check.checked;
                        postData.checklist = checklist;
                    })
                }
                else if (currentHash == tabs[2]) {
                    postData.flight_start_date = flight_start_date;
                    postData.flight_end_date = flight_end_date;
                }
                else if (currentHash == tabs[3]) {
                    sendPost = false;
                    updateTabHash();
                }

                if (sendPost) postToDB(postData, missionID);
            }

            openTab(nextTabHash);

            function postToDB(postData, missionID) {
                $.ajax({
                    url: `/portal/missions/details/${missionID}`,
                    type: "POST",
                    data: postData,
                    headers: {
                        'X-CSRF-TOKEN': token
                    },
                    success: function (result) {
                        successToast();
                        for (var obj in postData) delete postData[obj];
                        updateTabHash();
                        openTab(nextTabHash);
                    },
                    error: function (error) {
                        errorToast();
                    }
                })
            }

            function updateTabHash() {
                currentHash = nextTabHash;
            }
        });

        /**
         * INITIALIZE
         */
        // Load the correct tab when page loads
        openTabFromHash(tabs, window.location.hash);
    }

    // Cancel Mission is a button on a form, but requires confirmation
    $('.cancelMission').click(function (e) {
        if (!confirm('Are you sure you want to cancel this mission? Once you cancel a mission, it will be removed from your list of missions')) {
            e.preventDefault();
            return false;
        }
    });

    /**
     *
     * FILE UPLOADS
     *
     */
    // Element where files are dropped in to
    var dropzone = $('#uploadMissionData');
    if (dropzone.length == 1) {
        // Element where a list of uploaded files is shown
        var fileListContainer = $('.mission-data__file-list-container').first();
        // Stores data necessary to provide info necessary to post to AWS S3
        var uploadData;

        // First, request S3 upload data
        $.get(`/mission/data/requestUpload/${dropzone.data('id')}`).then(function (data) {
            uploadData = data;
            // With that data, set up the dropzone element
        }).done(function () {
            var filePath;
            dropzone.dropzone({
                paramName: 'file',
                // Upload to the specified 'action' in AWS S3
                url: uploadData.formAttributes.action,
                sending: function (file, _, formData) {
                    // Add in form inputs supplied to us
                    for (var i in uploadData.formInputs) {
                        // 'key' will be the file path + filename. We have been given the path
                        // in uploadData.formInputs.key, so add 'key'
                        if (i == 'key') {
                            filePath = uploadData.formInputs[i] + file.name;
                            formData.append(i, filePath);
                        } else {
                            formData.append(i, uploadData.formInputs[i]);
                        }
                    }
                },
                success: function () {
                    dropzone.find('.dz-preview').fadeOut(2000);

                    // Update file links by first recording our most recent upload
                    updateDataRecord(dropzone.data('id'), filePath).done(function () {
                        // and then ask for an updated list of all file links
                        updateFileLinks(dropzone.data('id'), fileListContainer);
                    });
                },
                error: function (a, response, ) {
                    errorToast('Error uploading file');
                }
            }).addClass('dropzone');
        });

        // POST an ID and filepath to be recorded for an upload
        function updateDataRecord(missionId, filePath) {
            return $.post({
                url: `/mission/data/addDataRecord`,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                data: {
                    id: missionId,
                    path: filePath,
                }
            });
        }
        /**
         * INITIALIZE
         */
        // Get uploaded files
        updateFileLinks(dropzone.data('id'), fileListContainer);
    }

    /**
     * ADMIN MISISON EDIT PAGE
     *
     * Show uploads if they exist
     */
    var missionUploadsContainer = $('#mission_uploads');
    if (missionUploadsContainer.length > 0) {
        var id = missionUploadsContainer.data('id');
        if (!id) return;
        updateFileLinks(id, missionUploadsContainer);
    }

    // GET a list of links from server, and add to template
    function updateFileLinks(missionId, container) {
        var url = `/mission/data/links/${missionId}`;
        return $.get({
            url: url,
            success: function (data) {
                var html = '';
                for (var i in data) {
                    html += `
                    <ul class="file-link__list">
                    <li class="filelink-list__item">
                    <a target="_blank" class="file-link__link" href="${data[i]}">${i}</a>
                    </li>
                    </ul>`;
                }
                container.html(html);
            }
        });
    }


    /**
     * COMPLETE MISSION
     */
    // Only allow complete mission if the checkbox is checked
    (function () {
        var checkbox = $('#mission_complete_confirmation');
        var completeButton = $('.mission-data__complete-button');
        checkbox.on('change', function () {
            updateCompleteButton();
        });
        function updateCompleteButton() {
            completeButton.attr('disabled', checkbox.is(':checked') ? false : true);
        }

        completeButton.on('click', function () {
            if (completeButton.is(':disabled')) return false;
            // Prompt complete mission with confirm dialog
            if (!confirm('Are you sure you want to complete the mission?')) return false;

            // Allow the form to submit if valid
            return true;
        });

        // Initialize
        updateCompleteButton();
    })();

});
